import type { IconProps } from '@/shared/ui/icons/types';

export const RadarIcon = (props: IconProps) => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth={2}
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
  >
    <path d="M19.07 4.93A10 10 0 0 0 6.99 3.34" />
    <path d="M4 6h.01" />
    <path d="M2.29 9.62A10 10 0 1 0 21.31 8.35" />
    <path d="M16.24 7.76A6 6 0 1 0 17.99 12" />
    <path d="M12 12a2 2 0 0 0 2-2" />
    <path d="m12 12 5-5" />
  </svg>
);
